var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c(
        "div",
        { staticClass: "padding_50" },
        [
          _c("vxe-toolbar", {
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    !_vm.disabled
                      ? _c(
                          "vxe-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.productNameClick()
                              },
                            },
                          },
                          [_vm._v("添加物料")]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "vxe-table",
            {
              ref: "fineTable",
              attrs: {
                "show-overflow": "",
                data: _vm.subjectList,
                "min-height": "100px",
                "max-height": "250px",
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "code", title: "物料编码" },
              }),
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "name", title: "物料名称" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "classifyName",
                  title: "物料分类",
                },
              }),
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "kind", title: "具体品类" },
              }),
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "spec", title: "规格型号" },
              }),
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "unitName", title: "单位" },
              }),
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "num", title: "数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var rowIndex = ref.rowIndex
                      return [
                        _c("el-input-number", {
                          attrs: {
                            precision: 0,
                            placeholder: "数量",
                            disabled: _vm.disabled,
                            controls: false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeNumber(row, rowIndex)
                            },
                          },
                          model: {
                            value: row.num,
                            callback: function ($$v) {
                              _vm.$set(row, "num", $$v)
                            },
                            expression: "row.num",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "price", title: "单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var rowIndex = ref.rowIndex
                      return [
                        _c("el-input-number", {
                          attrs: {
                            precision: 2,
                            placeholder: "单价",
                            disabled: _vm.disabled,
                            controls: false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeNumber(row, rowIndex)
                            },
                          },
                          model: {
                            value: row.price,
                            callback: function ($$v) {
                              _vm.$set(row, "price", $$v)
                            },
                            expression: "row.price",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "totalPrice",
                  title: "总价",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            placeholder: "总价",
                            disabled: "",
                            controls: false,
                          },
                          model: {
                            value: row.totalPrice,
                            callback: function ($$v) {
                              _vm.$set(row, "totalPrice", $$v)
                            },
                            expression: "row.totalPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "preCloseNum",
                  title: "已关闭数量",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            placeholder: "已关闭数量",
                            disabled: "",
                            controls: false,
                          },
                          model: {
                            value: row.preCloseNum,
                            callback: function ($$v) {
                              _vm.$set(row, "preCloseNum", $$v)
                            },
                            expression: "row.preCloseNum",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "preCloseAmount",
                  title: "已关闭金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            placeholder: "已关闭金额",
                            disabled: "",
                            controls: false,
                          },
                          model: {
                            value: row.preCloseAmount,
                            callback: function ($$v) {
                              _vm.$set(row, "preCloseAmount", $$v)
                            },
                            expression: "row.preCloseAmount",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm.buttonCode === "project_close"
                ? _c("vxe-table-column", {
                    attrs: {
                      "min-width": "100",
                      field: "curCloseNum",
                      title: "关闭数量",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            var rowIndex = ref.rowIndex
                            return [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "关闭数量",
                                  disabled: _vm.closeAllFlag === "1",
                                  controls: false,
                                  max: row.num - row.preCloseNum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeCloseNumber(row, rowIndex)
                                  },
                                },
                                model: {
                                  value: row.curCloseNum,
                                  callback: function ($$v) {
                                    _vm.$set(row, "curCloseNum", $$v)
                                  },
                                  expression: "row.curCloseNum",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1347332299
                    ),
                  })
                : _vm._e(),
              _vm.buttonCode === "project_close"
                ? _c("vxe-table-column", {
                    attrs: {
                      "min-width": "100",
                      field: "curCloseAmount",
                      title: "关闭金额",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "关闭金额",
                                  disabled: "",
                                  controls: false,
                                },
                                model: {
                                  value: row.curCloseAmount,
                                  callback: function ($$v) {
                                    _vm.$set(row, "curCloseAmount", $$v)
                                  },
                                  expression: "row.curCloseAmount",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      897220089
                    ),
                  })
                : _vm._e(),
              !_vm.disabled
                ? _c("vxe-table-column", {
                    key: "操作",
                    attrs: { title: "操作", width: "100", "show-overflow": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            var rowIndex = ref.rowIndex
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deletRow(row, rowIndex)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1697997809
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }